<template functional>
  <svg :class="[data.class, data.staticClass, 'stella-icon']" :style="data.staticStyle" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path v-if="props.filled" d="M19 14V6C19 4.9 18.1 4 17 4H7C5.9 4 5 4.9 5 6V18C5 19.1 5.9 20 7 20H15L19 16V14ZM12 7C13.66 7 15 8.34 15 10C15 11.66 13.66 13 12 13C10.34 13 9 11.66 9 10C9 8.34 10.34 7 12 7ZM14 18H7V16.68C7 15.35 9.68 14.68 11 14.68C11.53 14.68 12.35 14.81 13.11 15.09L14 15.42V18Z" fill="currentColor"/>
    <path v-else d="M17 4H7C5.9 4 5 4.9 5 6V18C5 19.1 5.9 20 7 20H17C18.1 20 19 19.1 19 18V6C19 4.9 18.1 4 17 4ZM17 18H7V6H17V18ZM12 7C10.34 7 9 8.34 9 10C9 11.66 10.34 13 12 13C13.66 13 15 11.66 15 10C15 8.34 13.66 7 12 7ZM12 11.2C11.34 11.2 10.8 10.66 10.8 10C10.8 9.34 11.34 8.8 12 8.8C12.66 8.8 13.2 9.34 13.2 10C13.2 10.66 12.66 11.2 12 11.2ZM12 14.5C9.99 14.5 7.9 15.5 7.9 16.5V17H16.1V16.5C16.1 15.5 14.01 14.5 12 14.5Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconTransactions",
  props: {
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
